import SalaryPageTemplate from "@/components/SalaryPageTemplate";
import { SALARY_DATA } from "@/data/salaryData";

export default function FrontendDeveloperSalary() {
  return <SalaryPageTemplate data={SALARY_DATA["frontend-developer"]} />;
}
